import React, { useState } from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import RightIcon from '../assets/images/right-icon.svg'
import XIcon from '../assets/images/radio.svg'
import { CREATE_ACCOUNT } from '../api/constants';
import Swal from 'sweetalert2';
function BecomeAgentCreateAccount() {
  const [error, setError] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');


  const [passwordValidation, setPasswordValidation] = useState({
    hasEightChars: false,
    hasLetterAndNumber: false,
    hasSpecialChar: false,
    hasUpperAndLowerCase: false
  });

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setPassword(password);
    // Validate password
    setPasswordValidation({
      hasEightChars: password.length >= 8,
      hasLetterAndNumber: /[a-zA-Z]/.test(password) && /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      hasUpperAndLowerCase: /[a-z]/.test(password) && /[A-Z]/.test(password)
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // Check required fields
    if (!email || !password || !first_name || !last_name || !username) {
      setError("All fields are required");
      return;
    }

    // Validate email
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Invalid email format");
      return;
    }

    // Validate password (min 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char)
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password)) {
      setError(
        "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character"
      );
      return;
    }

    setError("");
    // Call your API to create account
    fetch(CREATE_ACCOUNT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
        username,
        first_name,
        last_name,
        user_type_id: 5
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status) {
          //clear
          setEmail('');
          setPassword('');
          setUsername('');
          setFirstName('');
          setLastName('');

          Swal.fire({
            icon: 'success',
            title: 'Account created successfully',
            text: data.message
          });
        } else {
          setError(data.errors);
        }
      })
      .catch((error) => {
        console.error("Error creating account:", error);
        setError("Error creating account");
      });
  };
  return (
    <>
      <div className='main become-agent-create-account-page'>
        <Header/>
         <section className="create-account-section common-padding">
          <Container>
             <div className="common-header text-center">
                <h2 className='mb-0'>Become an <span>Agent</span> </h2>
              </div>
            <Row className="justify-content-center">
              <Col lg={6} md={10} sm={12}>
                <div className="account-form-wrapper">
                  <Form onSubmit={handleSubmit} className="create-account-form">
                    <Form.Group className="mb-3 form-group">
                      <Form.Label>
                        Email <span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3 form-group">
                      <Form.Label>
                        Password <span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Create Password"
                        value={password}
                        onChange={handlePasswordChange}
                        required
                      />
                      
                      <div className="password-validation">
                        <div className={`validation-item ${passwordValidation.hasEightChars ? 'valid' : ''}`}>
                          <img src={passwordValidation.hasEightChars ? RightIcon : XIcon} alt='' />
                          <span>At least 8 characters</span>
                        </div>
                        <div className={`validation-item ${passwordValidation.hasLetterAndNumber ? 'valid' : ''}`}>
                          <img src={passwordValidation.hasLetterAndNumber ? RightIcon : XIcon} alt='' />
                          <span>Mix of letters and numbers</span>
                        </div>
                        <div className={`validation-item ${passwordValidation.hasSpecialChar ? 'valid' : ''}`}>
                          <img src={passwordValidation.hasSpecialChar ? RightIcon : XIcon} alt='' />
                          <span>At least 1 special character</span>
                        </div>
                        <div className={`validation-item ${passwordValidation.hasUpperAndLowerCase ? 'valid' : ''}`}>
                          <img src={passwordValidation.hasUpperAndLowerCase ? RightIcon : XIcon} alt='' />
                          <span>At least 1 lowercase letter and 1 uppercase letter</span>
                        </div>
                      </div>
                    </Form.Group>
                   
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3 form-group">
                          <Form.Label>
                            First Name <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter first name"
                            value={first_name}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3 form-group">
                          <Form.Label>
                            Last Name <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter last name"
                            value={last_name}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-3 form-group">
                      <Form.Label>
                       Username <span className="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </Form.Group>
                    
                    <Button type="submit" className="custom-bttn w-100 style-3 mb-4 md-md-5">
                      Create Account
                    </Button>
                    {error && <p className="text-danger text-center">{error}</p>}

                    {/* Terms */}
                    <p className="terms-text text-center">
                      By submitting, I accept <Link to="/terms" className="terms-link">Real Estate</Link> terms of use.
                    </p>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  )
}
export default BecomeAgentCreateAccount


